import { render } from "./Profile-Others.vue?vue&type=template&id=3ed5c83a"
import script from "./Profile-Others.vue?vue&type=script&lang=js"
export * from "./Profile-Others.vue?vue&type=script&lang=js"

import "./Profile-Others.vue?vue&type=style&index=0&id=3ed5c83a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__